<app-table
    *ngIf="taxCreditTable"
    [table]="taxCreditTable"
    [title]="translationPrefix + 'header' | translate"
    [isResponsive]="true"
    [showOffset]="true"
    [noPadding]="true"
    [embedded]="true"
    [showSearch]="false"
    [useStickyHeader]="false"
    [useStickyActions]="true"
    (menuItemSelected)="onTableMenuAction($event)"
    ><ui-button class="buttons" [type]="'link'" (click)="openDialog()"
        ><mat-icon [svgIcon]="'plus'" />{{ translationPrefix + 'addButton' | translate }}</ui-button
    >
    <div class="empty">{{ 'employees.jobAndPay.taxCredits.empty' | translate }}</div></app-table
>

<ui-dialog
    [open]="!!currentlyOpenDialog"
    [isCloseable]="currentlyOpenDialog === 'VIEW'"
    [header]="translationPrefix + 'header'"
    [primaryButtonLabel]="currentlyOpenDialog === 'CREATE' ? 'save' : null"
    [secondaryButtonLabel]="currentlyOpenDialog === 'CREATE' ? 'cancel' : 'close'"
    [secondaryButtonType]="currentlyOpenDialog === 'CREATE' ? 'ghost' : 'primary'"
    (secondaryButtonPressed)="closeDialog()"
    (primaryButtonPressed)="createTaxCredit()"
    (opening)="onOpenDialog()"
    (closing)="closeDialog()"
    [actionsLocked]="!canCreateTaxCredit"
    [stickyButtons]="true"
    [stickyHeader]="true"
>
    <div tabindex="-1" [id]="INSTRUCTIONS_ID">{{ translationPrefix + 'instructions' | translate }}</div>
    <app-tax-credit-form class="loadable" [class.loading]="isLoading" [taxCredit]="taxCredit" />
</ui-dialog>

<ui-confirmation-dialog
    #confirmDeactivateDialog
    [primaryButtonLabel]="'employees.jobAndPay.taxCredits.tableActions.deactivate.label'"
    [secondaryButtonLabel]="'cancel'"
    [header]="'employees.jobAndPay.taxCredits.tableActions.deactivate.header' | translate: { year: taxCredit.year }"
>
    {{ 'employees.jobAndPay.taxCredits.tableActions.deactivate.body' | translate }}
</ui-confirmation-dialog>
